// src/components/dashboard/departmentadmin/StatTile.js
import React from 'react';
import DashboardCard from '../DashboardCard';

function StatTile({ title, icon, value, loading }) {
  return (
    <DashboardCard title={title} icon={icon} loading={loading}>
      <div className="text-center">
        <h2 className="mb-0">{value}</h2>
      </div>
    </DashboardCard>
  );
}

export default StatTile;
